import {
  AchProcessingSpeed,
  PaymentMethod
} from "../chunk-VZXPAOBM.js";
import {
  ProductRealmSchema
} from "../chunk-HJPR3SS7.js";

// checkout/checkout.schema.ts
import { z } from "zod";
var CartItemSchema = z.object({
  productId: z.union([z.string(), z.number()]),
  productCode: z.string().nullable().optional(),
  productName: z.string().optional(),
  quantity: z.number().int().positive("Quantity must be positive"),
  unitPrice: z.number().nonnegative().optional(),
  totalPrice: z.number().nonnegative().optional(),
  /** B2BWave brand ID - used for order partitioning */
  brandId: z.union([z.string(), z.number()]).optional(),
  /** Whether this product requires Metrc tracking (default true, false for CBD/merch) */
  requiresMetrcTracking: z.boolean().optional()
});
var DeliveryAddressSchema = z.object({
  address1: z.string().min(1, "Address is required"),
  address2: z.string().nullable().optional(),
  city: z.string().min(1, "City is required"),
  state: z.string().min(1, "State is required"),
  postalCode: z.string().min(5, "Valid postal code required"),
  country: z.string().default("United States"),
  name: z.string().optional(),
  comments: z.string().nullable().optional()
});
var ContactInformationSchema = z.object({
  name: z.string().min(1, "Contact name is required"),
  email: z.string().email("Valid email required"),
  phone: z.string()
});
var AchPaymentDetailsSchema = z.object({
  bankAccountId: z.string().uuid("Valid bank account ID required"),
  processingSpeed: z.nativeEnum(AchProcessingSpeed)
});
var CheckoutRequestSchema = z.object({
  // Customer information
  customerId: z.number().int().positive("Valid customer ID required"),
  customerEmail: z.string().email("Valid email required"),
  customerName: z.string().min(1, "Customer name is required"),
  // Cart
  cartItems: z.array(CartItemSchema).min(1, "At least one item required"),
  // Delivery
  deliveryAddress: DeliveryAddressSchema,
  // Contact
  contactInformation: ContactInformationSchema,
  // Payment
  paymentMethod: z.nativeEnum(PaymentMethod),
  achPayment: AchPaymentDetailsSchema.optional(),
  // Order details
  totalAmount: z.number().positive("Total amount must be positive"),
  addressbookId: z.number().int().positive().optional(),
  discountCode: z.string().optional(),
  hostDomain: z.string().optional(),
  // Customer comments for the order
  customerComments: z.string().optional(),
  // Organization delivery location (provides address + compliance license)
  organizationLocationId: z.string().uuid().optional(),
  // Self-healing: user-provided Metrc license number when location has none
  destinationLicenseNumber: z.string().optional(),
  // Product realm — determines compliance gates (default: cannabis for backward compat)
  realm: ProductRealmSchema.optional()
}).refine(
  (data) => {
    if (data.paymentMethod === "ach" /* ACH */) {
      return data.achPayment !== void 0;
    }
    return true;
  },
  {
    message: "ACH payment details required when payment method is ACH",
    path: ["achPayment"]
  }
);
var CheckoutResponseSchema = z.object({
  success: z.boolean(),
  orderNumber: z.number().int().positive().optional(),
  transactionId: z.string().uuid().optional(),
  status: z.string().optional(),
  error: z.string().optional(),
  reason: z.string().optional()
});
var VerifyDestinationLicenseRequestSchema = z.object({
  licenseNumber: z.string().min(1, "License number is required"),
  organizationLocationId: z.string().uuid("Valid location ID required")
});
var VerifyDestinationLicenseResponseSchema = z.object({
  valid: z.boolean(),
  licenseId: z.string().uuid().optional(),
  licenseNumber: z.string().optional(),
  reason: z.string().optional()
});
export {
  AchPaymentDetailsSchema,
  CartItemSchema,
  CheckoutRequestSchema,
  CheckoutResponseSchema,
  ContactInformationSchema,
  DeliveryAddressSchema,
  VerifyDestinationLicenseRequestSchema,
  VerifyDestinationLicenseResponseSchema
};
